export enum PaddingSizeStyle {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}
